import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";
import mop_growth from "../../../Artifacts/SalesSucessCenter/MOP_growth.png";
import ModalMuiTable from "../../../Components/Modals/ModalMuiTable.jsx";

const tqpInsightsApi = async (body) => {
  try {
    const res = await axInst.post(
      "dealer-sales-success-centre/sales_tqp_insights",
      body
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch TQP insights data");
  }
};

const growth_api = async (body) => {
  const response = await axInst.post(
    "dealer-sales-success-centre/total_mop_growth",
    body
  );
  return response.data;
};

const TqpInsights = () => {
  const { data, submitted } = useSelector((e) => e.filtersSalesSuccessCenter);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalApi, setModalApi] = useState("");
  const [modalHeading, setModalHeading] = useState("");

  const {
    data: tqpInsights_data,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["tqpInsights", submitted],
    queryFn: () => tqpInsightsApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  const { data: GrowthData } = useQuery({
    queryKey: ["growth", submitted],
    queryFn: () => growth_api(data),
    cacheTime: 0,
    staleTime: 0,
  });

  const renderBox = (title, values) => (
    <div className="bg-white shadow-[0_4px_6px_rgba(16,24,40,0.1)] p-2 rounded-md border border-[#E4E7EC]">
      <div className="flex justify-between border border-dashed border-[#00838F] p-1 rounded-md shadow-[0_4px_6px_rgba(16,24,40,0.1)] gap-1">
        <span className="font-semibold text-[13px]">{title}</span>
        <span className="text-[12px]">
          {values["Open C1A"] ?? values["Open C2"] ?? "-"}
        </span>
      </div>
      <div className="flex justify-between mt-1 gap-1">
        <div className="flex justify-between bg-[#C8E2FF] p-1 rounded-md border border-[#E4E7EC] shadow-[0_4px_6px_rgba(16,24,40,0.1)] w-1/2 gap-[2px]">
          <span className="text-[13px]">C/O</span>
          <span className="text-[12px]">{values["C/O"] ?? "-"}</span>
        </div>
        <div className="flex justify-between bg-[#BFF8FE] p-1 rounded-md border border-[#E4E7EC] shadow-[0_4px_6px_rgba(16,24,40,0.1)] w-1/2 gap-[2px]">
          <span className="text-[13px]">MTD </span>
          <span className="text-[12px]">{values["MTD"] ?? "-"}</span>
        </div>
      </div>
    </div>
  );

  const handleOpenModal = (api, heading) => {
    setModalApi(api);
    setModalHeading(heading);
    setIsModalOpen(true);
  };

  return (
    <div className="relative h-full">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && tqpInsights_data && (
        <div className="p-2 bg-white rounded-xl shadow h-full">
          <h2 className="pb-2 text-base font-semibold text-[#4c4c4c]">
            TQP Insights
          </h2>

          {/* C1A Section */}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {renderBox("Open C1A", tqpInsights_data["C1A"])}
            {renderBox("C1A > 7 Days", tqpInsights_data["C1A > 7 days"])}
          </div>

          {/* C2 Section */}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            {renderBox("Open C2", tqpInsights_data["C2"])}
            {renderBox("C2 > 7 Days", tqpInsights_data["C2A > 7 days"])}
          </div>
          <div className="grid grid-cols-2 gap-2 p-2  border-gray-200 mt-2 border-t ">
            <div className="flex items-center gap-3 p-1  text-sm font-semibold text-gray-600 border-r border-gray-200">
              <img src={mop_growth} alt="Truck Icon" className="w-5 h-5" />
              <div className="text-center">
                <div
                  className="underline cursor-pointer text-xs"
                  onClick={() =>
                    handleOpenModal(
                      "dealer-sales-success-centre/mop_growth_table",
                      "MOP Growth"
                    )
                  }
                >
                  MOP Growth (₹)
                </div>
                <div className="text-black text-sm">
                  {GrowthData?.MOP_Growth || 0}
                </div>
              </div>
            </div>

            <div className="flex gap-1 items-center p-1   text-sm font-semibold text-gray-600">
              <img src={mop_growth} alt="Truck Icon" className="w-5 h-5" />
              <div className="text-center">
                <div
                  className="underline cursor-pointer text-xs whitespace-nowrap"
                  onClick={() =>
                    handleOpenModal(
                      "dealer-sales-success-centre/mop_absolute_lob_wise",
                      "MTD MOP Absolute"
                    )
                  }
                >
                  MTD MOP Absolute (₹)
                </div>
                <div className="text-black text-sm">
                  {GrowthData?.MOP_Absolute || 0}
                </div>
              </div>
            </div>
          </div>

          {isModalOpen && (
            <ModalMuiTable
              open={isModalOpen}
              heading={modalHeading}
              apiEndpoint={modalApi}
              onClose={() => setIsModalOpen(false)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default TqpInsights;
